import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  TextField,
  FormControl,
  InputLabel,
  OutlinedInput,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";

import Correct from "assets/image/Correct.png";
import Wrong from "assets/image/Wrong.png";
import shape_1 from "assets/image/shape_1.svg";
import shape_2 from "assets/image/shape_2.svg";
import shape_3 from "assets/image/shape_3.svg";
import shape_4 from "assets/image/shape_4.svg";
import Check from "assets/icon/Check.svg";
import { tabToggle } from "redux/actions/master";
import InputMask from "react-input-mask";
import moment from "moment";
// import '../style.css'
import Loader from "components/Loading";
import { handleFile } from "components/handleFile";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import { postInfoPeserta } from "redux/actions/assestment";
import {
  setPeserta,
  uploadPeserta,
  uploadPeserta2,
  getDetailUser,
} from "redux/actions/peserta";
import { modalToggle, modalToggleReset } from "redux/actions/general";
import Modal from "components/Modal";
// import NotReady from './not_ready'

import Cookie from "universal-cookie";
const cookie = new Cookie();

const useStyles = makeStyles((theme) => ({
  textField: {
    [`& fieldset`]: {
      borderRadius: 8,
    },
    width: "100%",
    marginBottom: 15,
  },
}));

export default function Welcome(props) {
  const classes = useStyles();
  const token = cookie.get("login_cookie");
  const profile = cookie.get("profile_cookie");
  const [agree, setAgree] = useState(false);

  const dispatch = useDispatch();
  const peserta = useSelector((state) => state.peserta);

  const { detail_peserta } = peserta;

  useEffect(() => {
    setAgree(false);
    getUsert();
  }, []);

  const getUsert = async () => {
    // let res=await dispatch(getDetailUser(`/${profile.id}`))
    // if(res){
    //     if(res.data.completed){
    //         window.location.assign('/done')
    //     }
    // }
  };

  const clickAgree = () => {
    // window.location.assign('/disc/assestment')
    props.clickAgree();
  };

  const handleOpenIntegrityModal = (e) => {
    if (agree) {
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    dispatch(
      modalToggle({
        modal_open: true,
        modal_title: "Pengerjaan Situational Judgement Test (SJT) Online",
        modal_component: "integrity_agreement",
        modal_size: 700,
        modal_data: null,
        modal_action: handleAgreeFromModal,
      }),
    );
  };

  const handleAgreeFromModal = () => {
    setAgree(true);
    dispatch(modalToggleReset());
  };

  return (
    <div>
      <div className="welcome-wrapper">
        <div className="welcome-text">
          <div className="welcome-mobile">
            {props.timerComponent && (
              <div style={{ marginBottom: 12, display: "flex" }}>
                {props.timerComponent}
              </div>
            )}
            <h2>
              {props.ln === "id" ? "Selamat datang" : "Welcome"}{" "}
              <span>{detail_peserta.nama}</span>
            </h2>
            <p style={{ paddingInline: "5px" }}>{props.welcomeMessage}</p>
            <Button
              onClick={clickAgree}
              disabled={!agree}
              className="hide-mobile"
              style={{
                width: "80%",
                textTransform: "none",
                borderRadius: 20,
                fontWeight: "bold",
              }}
              color="primary"
              variant="contained"
              size="large"
            >
              {props.btnText}
            </Button>
          </div>
        </div>
        <div className="welcome-example">
          <img
            style={{ top: 35, left: -20 }}
            className="shape-img"
            src={shape_1}
            alt="shape"
          />
          <img
            style={{ top: 5, right: 50 }}
            className="shape-img"
            src={shape_2}
            alt="shape"
          />
          <img
            style={{ top: 350, left: -40 }}
            className="shape-img"
            src={shape_3}
            alt="shape"
          />
          <img
            style={{ bottom: 10, left: 300 }}
            className="shape-img"
            src={shape_4}
            alt="shape"
          />
          <img
            style={{ bottom: 30, right: 20 }}
            className="shape-img"
            src={shape_1}
            alt="shape"
          />

          <div className="card-example">
            {props.children}
            <br />
            <div style={{ textAlign: "center" }}>
              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  cursor: "default",
                }}
              >
                <Checkbox
                  color="primary"
                  checked={agree}
                  disabled={true}
                  name="checkedA"
                  style={{ cursor: "not-allowed" }}
                />
                <span
                  onClick={handleOpenIntegrityModal}
                  style={{
                    color: agree ? "#9e9e9e" : "#00abbd",
                    cursor: agree ? "default" : "pointer",
                    textDecoration: agree ? "none" : "underline",
                    fontWeight: 500,
                    marginLeft: -5,
                    transition: "all 0.3s ease",
                  }}
                >
                  {props.ln === "id"
                    ? "Saya menyetujui Pakta Integritas dan siap memulai tes"
                    : "I agree to the Integrity Pact and am ready to start the test"}
                </span>
              </div>
            </div>
          </div>
        </div>
        <br className="show-mobile" />
        <div className=" show-mobile div-flex div-justify-center">
          <Button
            onClick={clickAgree}
            disabled={!agree}
            style={{
              width: "100%",
              textTransform: "none",
              borderRadius: 20,
              fontWeight: "bold",
            }}
            color="primary"
            variant="contained"
            size="large"
          >
            {props.btnText}
          </Button>
        </div>
        <br className="show-mobile" />
      </div>
    </div>
  );
}
